import { CompilerComponent } from '@types';

import { block } from './block';
import { component } from './component';
import { defaultProps, protocolFactory } from './protocol';

export interface RadioAlternativeButtonProps {
  label: string;
  index: string;
  value: string;
  disabled: boolean;
}

export default {
  block,
  component,
  defaultProps,
  protocolFactory,
} as CompilerComponent<RadioAlternativeButtonProps>;
